import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import ArrowSVG from "../../../../../../SVGObjects/UiKit/ArrowSVG";
import stl from "./LatestOffer.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import GrantedPopup from "../../../../../../components/SearchComponent/NewComponents/GrantedPopup/GrantedPopup";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var LatestOffer = function LatestOffer(_ref) {
  var posts = _ref.posts,
    lazyOnly = _ref.lazyOnly,
    hasTitle = _ref.hasTitle,
    hasArrow = _ref.hasArrow;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.CLO_component
  }, hasTitle && /*#__PURE__*/React.createElement("h2", null, t("آخر عروض السيارات", {
    ns: "web_city"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.CLO_postsContainer
  }, posts.length ? posts === null || posts === void 0 ? void 0 : posts.map(function (post, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      key: post.id,
      post: post,
      showGrantedPopup: function showGrantedPopup() {
        return setShowGrantedPopup(true);
      },
      showGrantedLabel: true,
      rank: idx + 1
    }));
  }) : /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 325,
    numberOfLoaders: "8",
    hasCar: true
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    className: "redBtn ".concat(stl.customBtn, " ").concat(hasArrow ? stl.customBtnFlex : ""),
    onClick: function onClick() {
      return navigateTo("/filters");
    },
    loading: false
  }, t("تصفح جميع السيارات", {
    ns: "web_city"
  }), hasArrow && /*#__PURE__*/React.createElement(ArrowSVG, {
    filledColor: "white",
    className: "m-show ".concat(stl.rotateTheSVG)
  }))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement(GrantedPopup, null)));
};
export default LatestOffer;